<template>
  <van-goods-action :safe-area-inset-bottom="false">
    <orderForm ref="orderForm"
               :orderId="orderId"
               :timeout="timeout"
               :goodsInfo="goodsInfo"
    />
    <virtualOrder :orderId="orderId"
                  :timeout="timeout"
                  :goodsInfo="goodsInfo"
                  @changeBtnStatus="initOrderData"
                  ref="virtualOrder"
    />
    <van-goods-action-icon icon="wap-home-o" text="首页" to="/home" replace
                           :color="$route.path==='/home'?'#ff9933':'#999'"/>
    <van-goods-action-icon icon="orders-o" text="订单" to="/order" replace
                           :color="$route.path==='/order'?'#ff9933':'#999'"/>
    <van-goods-action-icon icon="chat-o" text="客服" to="/service" replace
                           :color="$route.path==='/service'?'#ff9933':'#999'"/>
    <van-goods-action-button
        type="warning"
        icon="shop-o"
        text="复购小店"
        @click="go8dFgShops"/>
    <template v-if="!isFinish">
      <van-goods-action-button color="#ccc" v-if="!isTimeOver">
        <van-count-down
            format="HH : mm : ss "
            :time="countDownTime"
            style="color: #ffffff"
            :auto-start="isStart"
            @finish="onCountDownFinish"
        />
      </van-goods-action-button>
      <van-goods-action-button v-if="isTimeOver && isGet && !isPayed" color="red" text="有订单未支付"
                               @click="onOrderPay"/>
      <van-goods-action-button v-if="isTimeOver && isPayed" text="已秒得" color="#ccc"/>
      <van-goods-action-button v-if="isTimeOver && isFinish" text="活动已结束" color="#ccc"/>
      <van-goods-action-button v-if="isTimeOver && isEmpty" text="已抢光" color="#ccc"/>
      <van-goods-action-button v-if="$skillType===1&& isTimeOver && !isGet && !isPayed"
                               text="立即抢购" type="danger" @click="onClickBuy"/>
      <van-goods-action-button v-if="$skillType===0&& isTimeOver && !isFinish && !isEmpty && !isGet"
                               text="立即抢购" type="danger" @click="onClickBuy"/>

    </template>
    <van-goods-action-button v-if="isFinish"
                             text="今日活动已结束" type="danger" color="#c5c5c5"/>

  </van-goods-action>
</template>

<script>
import EApi from "@/api/home";
import {getSecOrderInfo} from "@/api/virtual";
import axios from "axios";
import {mapState} from "vuex"
import {finishTask} from "@/api/task";
import orderForm from "@/components/order-form";
import virtualOrder from "@/components/virtual-order";

export default {
  components: {orderForm, virtualOrder},
  name: "Tabbar",
  data() {
    return {
      timer: null,
      orderId: 0,
      timeout: 0,
      goodsInfo: {}
    }
  },
  computed: {
    ...mapState(["isTimeOver",
      "isGet",
      "isPayed",
      "isFinish",
      "isStart",
      "isEmpty",
      "countDownTime"])
  },
  created() {
    this.createdFn()
  },

  methods: {
    //初始化后
    createdFn() {
      if (this.$skillType === 1 && !this.$store.state.city) {
        SmartCity.getLocation((res) => {
          console.log(res, "虚拟商品获取用户地址");
          if (res.city) {
            this.$store.commit("setCity", res.city);
          }
        });
      }
      if (process.env.NODE_ENV === "development") {
        this.$store.commit("setUserTokenKey", "b819f6472575f02128c5bd851dbfda74");
        this.$store.commit("setNthUserInfo", {
          userid: "1075"
        });
        this.$store.commit("setDeviceToken", "res2.deviceInfo.device_token");
        this.initOrderData();
        this.finishTask();
      } else if (process.env.NODE_ENV === "test") {
        this.init();
      } else {
        this.init();
      }
    },
    //判断是否是app
    init() {
      const isApp = SmartCity.isSmartCityApp();
      if (isApp) {
        this.getNthUserInfo();
      } else {
        this.$router.replace("/share");
      }
    },
    //积分任务
    async finishTask() {
      console.log(this.$store.state.userInfo);
      const {data: res} = await finishTask({
        m2oId: this.$store.state.nthUserInfo.userid
      });
      console.log(res);
      if (res.code === 200) {
        if (res.data) {
          SmartCity.creditRulesUpdate({
            availableScore: res.data.availableScore
          });
          this.$toast(res.data.message);
        }

        // this.getFavoriteServeList()
      }
    },
    //初始化订单数据
    async initOrderData() {
      let params = {m2oId: this.$store.state.nthUserInfo.userid}
      const {data: res} = this.$skillType === 0 ? await EApi.getSecOrderInfo(params) : await getSecOrderInfo(params)
      if (res.code === 200) {
        this.orderId = res.data.id;
        this.timeout = res.data.timeout;
        await this.$store.dispatch("awaitBuyTimer", this.timeout)
        this.$store.commit("setIsGet", true)
      } else {
        if (res.code === 200100) {
          this.$store.commit("setIsEmpty", true)
        }
        if (res.code === 200005) {
          this.$store.commit("setIsPayed", true)
        }
        if (res.code === 200102) {
          this.$store.commit("setIsFinish", true)
        }
      }
    },
    //  获取南太湖用户信息
    getNthUserInfo() {
      this.$toast.loading({
        duration: 0,
        message: "加载中..."
      });
      SmartCity.getUserInfo((res) => {
        console.log(res)
        if (res && res.userInfo) {
          this.$toast.clear();
          this.$store.commit("setNthUserInfo", res.userInfo);
          this.$store.commit("setUserTokenKey", res.userInfo.userTokenKey);
          SmartCity.getSystemInfo(res => {
            this.$store.commit("setDeviceToken", res.deviceInfo.device_token)
          })
          this.initOrderData();
          this.finishTask();
        } else {
          this.$toast.clear();
          this.$dialog
              .alert({
                title: "提醒",
                message: "请先登录南太湖号"
              })
              .then(() => {
                this.$router.replace("/error-unlogin");
              });
        }
      });
    },
    //前往八点复购店
    go8dFgShops() {
      let url = ""
      if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
        url = "https://flash-sale-backend-test.zhijianmedia.cn/order/"
      } else {
        url = "https://flash-sale-api.zhijianmedia.cn/order"
      }
      axios.get(url + '/secHome/countEdmdToRepeatBusiness', {
        methods: "Get",
      }).then(res => {
        window.location.href = "http://prod-app-frontend.zhijianmedia.cn/south-taihu-store/#/?brandId=62"
      }).catch(err => {
        window.location.href = "http://prod-app-frontend.zhijianmedia.cn/south-taihu-store/#/?brandId=62"
      })
    },
    //前往购买
    onClickBuy() {
      let secKillUrl = process.env.VUE_APP_ROB_URL;
      if (this.$skillType === 0) {
        if (this.goodsInfo.linkUrl) {
          return SmartCity.linkTo({
            innerLink: this.goodsInfo.linkUrl
          })
        } else {
          this.doEntitySecKill(secKillUrl)
        }
      } else {
        this.doVirtualSecKill(secKillUrl)
      }
    },
    //虚拟
    async doVirtualSecKill(secKillUrl) {
      this.$toast.loading({
        duration: 0,
        message: "抢购中..."
      });
      axios
          .post(secKillUrl + "/secKill/doVirtualSecKill", {
            m2oId: this.$store.state.nthUserInfo.userid,
            token: this.$store.state.token,
            deviceToken: this.$store.state.deviceToken
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$toast.clear();
              this.createTimer();
            } else {
              if (res.data.code === 200100) {
                this.$store.commit("setIsEmpty", true)
              }
              if (res.data.code === 200102) {
                this.$store.commit("setIsFinish", true)
              }
              return this.$toast.fail(res.data.msg);
            }
          })
          .catch((err) => {
            this.$toast.clear();
            if (err.request.status === 429) {
              this.$toast.clear();
            }
          });
    },
    //实体
    async doEntitySecKill(secKillUrl) {
      this.$toast.loading({
        duration: 0,
        message: "抢购中..."
      });
      const {data: res} = await axios.post(
          secKillUrl + "/secKill/doSecKill",
          {
            m2oId: this.$store.state.nthUserInfo.userid,
            token: this.$store.state.token
          }
      );
      console.log("抢购中", res);
      if (res.code === 200) {
        this.$toast.clear();
        this.createTimer();
      } else {
        this.$toast.clear();
        return this.$toast.fail(res.msg);
      }
    },
    //获取订单详情
    async getOrder() {
      let params = {m2oId: this.$store.state.nthUserInfo.userid}
      const {data: res} = this.$skillType === 0 ? await EApi.getSecOrderInfo(params) : await getSecOrderInfo(params)
      if (res.code === 200) {
        this.stopTimer();
        this.$skillType === 0 ? this.$refs.orderForm.popupShow = true : this.$refs.virtualOrder.show = true;
        this.orderId = res.data.id;
        this.timeout = res.data.timeout;
        this.goodsInfo = {...res.data}

        this.$toast.clear();
      }
      if (res.code === 200004) {
        this.$toast.loading({
          duration: 2000,
          message: "订单创建中",
          loadingType: "spinner"
        });
      }
    },
    createTimer() {
      this.stopTimer();
      this.timer = setInterval(this.getOrder, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //前往订单页面
    onOrderPay() {
      if (this.$route.path === "/order") return
      this.$router.replace("/order");
    },
    //倒计时结束
    onCountDownFinish() {
      this.$store.commit("setIsTimeOver", true)
    },
  },
  destroyed() {
    this.stopTimer();
  },

}
</script>

<style scoped>
/deep/ .van-goods-action {
  font-weight: 600;
  box-shadow: 0px 2px 10px 0px rgba(255, 153, 29, 0.1);
  box-shadow: 0px 10px 9px 4px rgba(170, 152, 152, 0.75);
}

/deep/ .van-goods-action-icon__icon, /deep/ .van-button__icon {
  font-size: 24px;
  font-weight: 500;
}
</style>
